// src/routes.js
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";

// src/routes.js
function PrivateRoute({ children }) {
  const token = localStorage.getItem("token");
  const tokenExpiry = localStorage.getItem("tokenExpiry");

  const isValid = token && tokenExpiry && Date.now() < Number(tokenExpiry);

  return isValid ? children : <Navigate to="/login" />;
}

export default function AppRoutes() {
  return (
    <Routes>
    <Route path="/" element={<Navigate to="/login" />} />
      <Route path="/login" element={<Login />} />
      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <Dashboard  />
          </PrivateRoute>
        }
      />
      <Route path="*" element={<Navigate to="/login" />} />
    </Routes>
  );
}
